export function isNotEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined
}

export const isString = (value: unknown): value is string => typeof value === 'string'

type QueryParamValue = string | boolean | number

export const removeUndefinedValues = <T extends Record<string, QueryParamValue | undefined>>(
  obj: T
): Record<string, QueryParamValue> =>
  Object.fromEntries(
    Object.entries(obj).filter(
      (entry): entry is [string, QueryParamValue] => entry[1] !== undefined
    )
  )
